import React from 'react';
import Divider from '~/components/atom/Divider';
import JustificationContainer from '~/components/atom/JustificationContainer';
import CommentsIndicator from '../CommentsIndicator';
import type { Lfa_Conversion_Details, Lfa_NoteInfo } from '~/graphql/types';
import FeedbackGiven from './components/FeedbackGiven';
import WaitingForFeedback from './components/WaitingForFeedback';
import type { CardStatus } from '~/components/page/LFA/utils/getFrontendStatus';

const text = {
  noLatestNode: 'Geen notitie',
};

export type Props = {
  dataTestId?: string;
  className?: string;
  frontendStatus: CardStatus;
  autoAcceptDate: Lfa_Conversion_Details['autoAcceptDate'];
  noteInfo?: Lfa_NoteInfo;
  finalFeedbackGivenDate?: Lfa_Conversion_Details['finalFeedbackGivenDate'];
};

const StatusDescription: React.FCC<Props> = ({
  dataTestId,
  className,
  frontendStatus,
  autoAcceptDate,
  noteInfo,
  finalFeedbackGivenDate,
}) => {
  if (frontendStatus === 'prepareForAppointment') return null;
  const isFeedbackGiven =
    frontendStatus === 'rejected' || frontendStatus === 'completed';
  const isWaitingForFeedback =
    frontendStatus === 'waitingForFeedback' || frontendStatus === 'expiring';

  return (
    <>
      <Divider margin={[null]} />
      <JustificationContainer
        padding={['xs', 'm', 'base', 'm']}
        width="100%"
        className={className}
        dataTestId={dataTestId}
      >
        {isFeedbackGiven && finalFeedbackGivenDate && (
          <FeedbackGiven finalFeedbackGivenDate={finalFeedbackGivenDate} />
        )}
        {isWaitingForFeedback && (
          <WaitingForFeedback autoAcceptDate={autoAcceptDate} />
        )}
        {noteInfo && noteInfo.noteTotal > 0 && (
          <JustificationContainer>
            <CommentsIndicator
              commentsCount={noteInfo?.noteTotal}
              latestComment={noteInfo?.lastNote || text.noLatestNode}
            />
          </JustificationContainer>
        )}
      </JustificationContainer>
    </>
  );
};

export default StatusDescription;
